import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Loader2, Trophy } from "lucide-react";
import api from "@/lib/api";
import { tInput, useTrackEvents } from "./trackUi";

export default function TrackRankings({ orgId }) {
  const events = useTrackEvents();
  const [event, setEvent] = useState("100m");
  const [gender, setGender] = useState("");
  const [board, setBoard] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!orgId || !event) return;
    setLoading(true);
    api.get(`/track/rankings?event=${event}&organization_id=${orgId}${gender ? `&gender=${gender}` : ""}`)
      .then(({ data }) => setBoard(data)).catch(() => toast.error("Failed to load rankings.")).finally(() => setLoading(false));
  }, [orgId, event, gender]);

  return (
    <div data-testid="track-rankings">
      <h1 className="font-display font-black uppercase tracking-tighter text-4xl mb-6">Team Rankings</h1>
      <div className="flex gap-3 mb-6 flex-wrap">
        <select data-testid="rank-event" value={event} onChange={(e) => setEvent(e.target.value)} className={`${tInput} max-w-[220px]`}>
          {events.map((ev) => <option key={ev.code} value={ev.code}>{ev.name}</option>)}
        </select>
        <select data-testid="rank-gender" value={gender} onChange={(e) => setGender(e.target.value)} className={`${tInput} max-w-[160px]`}>
          <option value="">All</option><option value="M">Male</option><option value="F">Female</option>
        </select>
      </div>
      {loading ? <div className="flex justify-center py-16 text-white/40"><Loader2 className="animate-spin" /></div>
        : !board?.leaderboard?.length ? <div className="border border-white/10 bg-[#121212] p-6 text-white/40 text-sm" data-testid="rankings-empty">No results recorded for {board?.event_name || event} yet.</div>
        : (
          <div className="border border-white/10 bg-[#121212] overflow-x-auto" data-testid="rankings-board">
            <table className="w-full text-sm">
              <thead><tr className="border-b border-white/10 text-white/40">{["Rank", "Athlete", "Grad", "Best"].map((h, i) => <th key={i} className="text-left font-mono-accent text-[10px] tracking-[0.2em] uppercase px-4 py-3">{h}</th>)}</tr></thead>
              <tbody>
                {board.leaderboard.map((r) => (
                  <tr key={r.athlete_id} data-testid={`rank-${r.athlete_id}`} className="border-b border-white/5">
                    <td className="px-4 py-3"><span className={`inline-flex items-center gap-1.5 font-display font-black ${r.rank === 1 ? "text-white" : "text-white/60"}`}>{r.rank === 1 && <Trophy size={14} />}#{r.rank}</span></td>
                    <td className="px-4 py-3 font-bold">{r.athlete_name}</td>
                    <td className="px-4 py-3 text-white/50">{r.grad_year || "—"}</td>
                    <td className="px-4 py-3 font-mono-accent">{r.display}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
    </div>
  );
}
